module.exports = __webpack_public_path__ + "img/culture_01.8c0f1a14.png";